import { actionCreator, Joi, objectSchemaOf } from '../helpers';
import type { RequestFieldKey } from '../user-input';
import { requestFieldKeySchema } from '../user-input';
import { SENTIENCE_INPUT } from './topics';

export const INPUT = 'SENTIENCE/INPUT';

export interface IInputPayload {
  conversationId: string;
  consoleId: string;
  organisationId: string;
  inputKey: RequestFieldKey;
  value: string;
}

export const inputPayloadSchema = objectSchemaOf<IInputPayload>({
  conversationId: Joi.string().required(),
  consoleId: Joi.string().required(),
  organisationId: Joi.string().required(),
  inputKey: requestFieldKeySchema.required(),
  value: Joi.string().allow('').required(),
});

export interface IInputAction {
  type: typeof INPUT;
  payload: IInputPayload;
}

export const inputActionSchema = objectSchemaOf<IInputAction>({
  type: Joi.string().valid(INPUT),
  payload: inputPayloadSchema.required(),
});

export const input = actionCreator({
  schema: inputActionSchema,
  topic: SENTIENCE_INPUT,
  type: INPUT,
});
